import { useMutation, useQueryClient } from 'react-query';
import { applicationKeys } from '../cache-keys/applicationKeys';
import { loan_application_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { loan_application } from '@axo/shared/data-access/types';

export function useArchiveApplication(applicationID: string) {
  const client = useQueryClient();
  const api = useAPI();
  return useMutation(
    (archiveType: loan_application.ArchiveRequestType) =>
      loan_application_api.archiveLoanApplication(api)(
        applicationID,
        archiveType
      ),
    {
      onSuccess: () => {
        client.invalidateQueries(applicationKeys.detail({ applicationID }));
        client.invalidateQueries(applicationKeys.loanQuotes({ applicationID }));
      },
    }
  );
}
